import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export var MeetingParticipantsType;
(function (MeetingParticipantsType) {
    MeetingParticipantsType["WITH_EXTERNAL_PARTICIPANTS"] = "WITH_EXTERNAL_PARTICIPANTS";
    MeetingParticipantsType["WITH_INTERNAL_PARTICIPANTS"] = "WITH_INTERNAL_PARTICIPANTS";
})(MeetingParticipantsType || (MeetingParticipantsType = {}));
export function MeetingParticipantsTypeFilter(_a) {
    var _b;
    var _c = _a.isDisplayLabel, isDisplayLabel = _c === void 0 ? true : _c;
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var meetingParticipantsType = useFilters().meetingParticipantsType;
    var options = [
        {
            id: null,
            name: t('filters.meetingParticipantsType.any'),
            isAll: true
        },
        {
            id: MeetingParticipantsType.WITH_INTERNAL_PARTICIPANTS,
            name: t('filters.meetingParticipantsType.WITH_INTERNAL_PARTICIPANTS')
        },
        {
            id: MeetingParticipantsType.WITH_EXTERNAL_PARTICIPANTS,
            name: t('filters.meetingParticipantsType.WITH_EXTERNAL_PARTICIPANTS')
        }
    ];
    var selectedMeetingParticipantsType = (_b = options.find(function (option) { return option.id === meetingParticipantsType; })) !== null && _b !== void 0 ? _b : options[0];
    var onChange = function (meetingParticipantsType) {
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                meetingParticipantsType: meetingParticipantsType.id
            }
        });
    };
    return (_jsx(Select, { isDisplayLabel: isDisplayLabel, selected: selectedMeetingParticipantsType, options: options, onChange: onChange, placeholder: t('filters.selectMeetingParticipantsType'), className: "w-full" }));
}
